import { ethers } from "ethers";
import type { HexString } from "@/types/general.types";

type WormholeRouteDataParams = {
  gasLimit: bigint;
  executorCost: bigint;
  refundAddress: HexString;
  signedQuote: HexString;
  receiverValue?: bigint;
  extraRelayInstructions?: HexString;
};

/**
 * Encodes WormholeAdapter1155.RoutingData for bridgeRoutingData_/routeData_.
 */
export const encodeWormholeRouteData = ({
  gasLimit,
  executorCost,
  refundAddress,
  signedQuote,
  receiverValue = BigInt(0),
  extraRelayInstructions = "0x",
}: WormholeRouteDataParams): HexString => {
  const abiCoder = ethers.AbiCoder.defaultAbiCoder();
  return abiCoder.encode(
    [
      "tuple(uint256 gasLimit,uint256 executorCost,address refundAddress,bytes signedQuote,uint128 receiverValue,bytes extraRelayInstructions)",
    ],
    [
      {
        gasLimit,
        executorCost,
        refundAddress,
        signedQuote,
        receiverValue,
        extraRelayInstructions,
      },
    ],
  ) as HexString;
};

/**
 * Encodes BridgeResilient routingConfig_ as abi.encode(bridgeAdapter, routingData).
 */
export const encodeBridgeRoutingConfig = (
  bridgeAdapter: HexString,
  routeData: HexString,
): HexString => {
  const abiCoder = ethers.AbiCoder.defaultAbiCoder();
  return abiCoder.encode(["address", "bytes"], [bridgeAdapter, routeData]) as HexString;
};
